import React, { Component } from 'react';
import * as styles from './editQuestionsRadio.style';
import { cx } from '@emotion/css';
import { title } from './questionWithTextFeild.style';

class EditQuestionwithRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: this.props.question,
      correctanswer: this.props.correctanswer,
      subcategory: this.props.subcategory,
      choice1: this.props.answer[0],
      choice2: this.props.answer[1],
      choice3: this.props.answer[2],
      choice4: this.props.answer[3],
    };

    ////console.log("this.state.question")

    ////console.log(this.props.question)
    ////console.log(this.state.subcategory)
    ////console.log(this.state.question)

    //this.handleQuestionChange = this.handleQuestionChange.bind(this);
  }

  handleCorrectAnswerChange(event) {
    this.setState({ correctanswer: event.target.value });
    this.props.selectedanswer(this.state.question, event.target.value, [
      this.state.choice1,
      this.state.choice2,
      this.state.choice3,
      this.state.choice4,
    ]);

    //this.props.selected(event.target.value,'1');
  }

  handlechoice1(event) {
    this.setState({ choice1: event.target.value });

    this.props.selectedanswer(this.state.question, this.state.correctanswer, [
      event.target.value,
      this.state.choice2,
      this.state.choice3,
      this.state.choice4,
    ]);
  }

  handlechoice2(event) {
    this.setState({ choice2: event.target.value });
    this.props.selectedanswer(this.state.question, this.state.correctanswer, [
      this.state.choice1,
      event.target.value,
      this.state.choice3,
      this.state.choice4,
    ]);
  }

  handlechoice3(event) {
    this.setState({ choice3: event.target.value });
    this.props.selectedanswer(this.state.question, this.state.correctanswer, [
      this.state.choice1,
      this.state.choice2,
      event.target.value,
      this.state.choice4,
    ]);
  }

  handlechoice4(event) {
    this.setState({ choice4: event.target.value });
    this.props.selectedanswer(this.state.question, this.state.correctanswer, [
      this.state.choice1,
      this.state.choice2,
      this.state.choice3,
      event.target.value,
    ]);
  }

  handleQuestionChange(event) {
    this.setState({ question: event.target.value });
    //this.props.selected(event.target.value,'1');

    ////console.log(this.state.subcategory)
    ////console.log(this.state.subcategory)
    this.props.selectedanswer(event.target.value, this.state.correctanswer, [
      this.state.choice1,
      this.state.choice2,
      this.state.choice3,
      this.state.choice4,
    ]);
  }

  handlecategoryChange(event) {
    this.setState({ subcategory: event.target.value });
    //this.props.selectedquestion(event.target.value,'1');
    this.props.selectedanswer(
      event.target.value,
      this.state.correctanswer,
      this.state.question,
      [
        this.state.choice1,
        this.state.choice2,
        this.state.choice3,
        this.state.choice4,
      ]
    );
  }

  // selectedanswer=(answer,id) =>{

  //    //////console.log(answer)
  //   // ////console.log(id)

  //     this.props.selected(answer,id);

  // }

  deletequestion() {
    ////console.log("Let me delete the question")
  }

  handleAnswer = (e) => {
    this.handleCorrectAnswerChange(e);
  };

  render() {
    return (
      <div className="questionBox">
        <h2 className={cx(title)}>
          <span>Q{this.props.questionnumber}/</span>
          {this.props.totalquestions}
        </h2>

        <div className={styles.form}>
          <div className="form-group">
            <label className="label" htmlFor="">
              Question:
            </label>
            <input
              spellCheck="false"
              autoComplete="off"
              className="input"
              type="text"
              rows={5}
              columns={5}
              id={this.props.id}
              value={this.state.question}
              onChange={(e) => {
                this.handleQuestionChange(e);
              }}
            />
          </div>
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label className="label" htmlFor="">
                  Choice 1:
                </label>
                <div className="flex">
                  <label className="c-input">
                    <input
                      onChange={this.handleAnswer}
                      type="radio"
                      name="correct"
                      value={this.state.choice1}
                      checked={this.state.choice1 === this.state.correctanswer}
                    />
                    <span className="checkmark" />
                  </label>
                  <input
                    spellCheck="false"
                    autoComplete="off"
                    type="text"
                    className={`input ${
                      this.state.correctanswer === this.state.choice1
                        ? ' is-correct'
                        : ''
                    }`}
                    rows={5}
                    columns={5}
                    id={this.props.id}
                    value={this.state.choice1}
                    onChange={(e) => {
                      this.handlechoice1(e);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="form-group">
                <label className="label" htmlFor="">
                  Choice 2:
                </label>
                <div className="flex">
                  <label className="c-input">
                    <input
                      onChange={this.handleAnswer}
                      type="radio"
                      name="correct"
                      value={this.state.choice2}
                      checked={this.state.choice2 === this.state.correctanswer}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <input
                    spellCheck="false"
                    autoComplete="off"
                    type="text"
                    rows={5}
                    className={`input ${
                      this.state.correctanswer === this.state.choice2
                        ? ' is-correct'
                        : ''
                    }`}
                    columns={5}
                    id={this.props.id}
                    value={this.state.choice2}
                    onChange={(e) => {
                      this.handlechoice2(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="form-group">
                <label className="label" htmlFor="">
                  Choice 3:
                </label>
                <div className="flex">
                  <label className="c-input">
                    <input
                      onChange={this.handleAnswer}
                      type="radio"
                      name="correct"
                      value={this.state.choice3}
                      checked={this.state.choice3 === this.state.correctanswer}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <input
                    type="text"
                    spellCheck="false"
                    autoComplete="off"
                    rows={5}
                    columns={5}
                    className={`input ${
                      this.state.correctanswer === this.state.choice3
                        ? ' is-correct'
                        : ''
                    }`}
                    id={this.props.id}
                    value={this.state.choice3}
                    onChange={(e) => {
                      this.handlechoice3(e);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="form-group">
                <label className="label" htmlFor="">
                  Choice 4:
                </label>
                <div className="flex">
                  <label className="c-input">
                    <input
                      onChange={this.handleAnswer}
                      type="radio"
                      name="correct"
                      value={this.state.choice4}
                      checked={this.state.choice4 === this.state.correctanswer}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <input
                    type="text"
                    spellCheck="false"
                    autoComplete="off"
                    className={`input ${
                      this.state.correctanswer === this.state.choice4
                        ? ' is-correct'
                        : ''
                    }`}
                    rows={5}
                    columns={5}
                    id={this.props.id}
                    value={this.state.choice4}
                    onChange={(e) => {
                      this.handlechoice4(e);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className="form-group">
            <label className="label" htmlFor="">
              Answer
            </label>
            <input
              type="text"
              className={`input ${this.state.correctanswer === this.state.choice1 ? ' is-correct' : ''}`}
              id={this.props.id}
              value={this.state.correctanswer}
              onChange={(e) => {
                this.handleCorrectAnswerChange(e);
              }}
            />
          </div> */}
        </div>
      </div>
    );
  }
}

export default EditQuestionwithRadio;
